(function () {
  if (customElements.get('cart-drawer')) return;

  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement, { preventScroll: true });
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      publish(PUB_SUB_EVENTS.cartRerendered, { source: 'cart-drawer' });

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();

(function () {
  if (customElements.get('cart-drawer-items')) return;

  class CartDrawerItems extends window.CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
})();

(function () {
  // CFSN-527 — guard so the open_cart query-param handler doesn't double-attach
  // when this file is evaluated more than once on the same page.
  if (window.__cartDrawerOpenCartParamHandlerAttached) return;
  window.__cartDrawerOpenCartParamHandlerAttached = true;

  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    if (params.has('open_cart')) {
      const url = new URL(window.location);
      url.searchParams.delete('open_cart');
      history.replaceState(null, '', url.pathname + url.search);

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    }
  });
})();

(function () {
  // DATORACODE - Drag-to-Scroll fuer die Payment-Icon-Leiste (Maus wie Touch-Swipe).
  // Delegiert auf document, damit es das Re-Rendern des Drawers ueberlebt.
  if (window.__cartDrawerPaymentIconsDragAttached) return;
  window.__cartDrawerPaymentIconsDragAttached = true;

  const SELECTOR = '.cart-drawer__payment-icons';
  let track = null;
  let dragPointerId = null;
  let startX = 0;
  let startScrollLeft = 0;

  // DATORACODE - Greif-Cursor nur zeigen, wenn tatsaechlich Ueberlauf vorhanden ist.
  const syncScrollableState = () => {
    document.querySelectorAll(SELECTOR).forEach((icons) => {
      icons.classList.toggle('is-scrollable', icons.scrollWidth > icons.clientWidth);
    });
  };
  subscribe(PUB_SUB_EVENTS.cartRerendered, syncScrollableState);
  window.addEventListener('resize', syncScrollableState);
  syncScrollableState();

  // Nur den Pointer beenden, der den Drag gestartet hat.
  const endDrag = (event) => {
    if (!track || (event && event.pointerId !== dragPointerId)) return;
    track.classList.remove('is-dragging');
    track = null;
    dragPointerId = null;
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    const icons = event.target.closest && event.target.closest(SELECTOR);
    if (!icons || icons.scrollWidth <= icons.clientWidth) return;

    track = icons;
    dragPointerId = event.pointerId;
    startX = event.clientX;
    startScrollLeft = icons.scrollLeft;
    icons.classList.add('is-dragging');
    icons.setPointerCapture(event.pointerId);
  });

  document.addEventListener('pointermove', (event) => {
    if (!track || event.pointerId !== dragPointerId) return;

    // Taste zwischendurch losgelassen (z. B. Kontextmenue) -> Drag beenden.
    if (event.buttons === 0) {
      endDrag(event);
      return;
    }

    track.scrollLeft = startScrollLeft - (event.clientX - startX);
    event.preventDefault();
  });

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('lostpointercapture', endDrag);
})();
